// extracted by mini-css-extract-plugin
export default {"wrapper":"Stats_wrapper__5HWNY","icon":"Stats_icon__o9bJH"};